import { Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';

import { BarChartData } from '@core/interfaces/charts';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { BarVerticalComponent } from '@swimlane/ngx-charts';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  selector: 'vertical-bar-chart',
  templateUrl: './vertical-bar.component.html',
  styleUrls: ['./vertical-bar.component.scss'],
})
export class VerticalBarChartComponent implements OnInit, OnChanges, OnDestroy {

  @Input() results: BarChartData = [];
  @Input() title: string;
  @Input() isLoading = true;
  @Input() xAxis = true;
  @Input() yAxis = false;
  @Input() roundEdges = true;
  @Input() showGridLines = false;
  @Input() rotateXAxisTicks = true;
  @Input() color: string;
  @Input() showDataLabel = true;
  @Input() yAxisTickFormatting = '2-digit';
  @Output() select = new EventEmitter<any>();
  @Input() hasData: Boolean;

  @ViewChild(BarVerticalComponent, { static: false }) chart: BarVerticalComponent;

  private readonly subscriptions = new Subject<void>();

    constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  ngOnDestroy(): void {
    this.subscriptions.next();
    this.subscriptions.complete();
  }

  ngOnInit(): void {
    const navbar = document.querySelector('fce-sidebar');

    fromEvent(navbar, 'toggleSidebar')
      .pipe(takeUntil(this.subscriptions), debounceTime(100), filter(() => !!this.chart))
      .subscribe(() => this.chart.update());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.results && changes.results.currentValue) {
      this.results = changes.results.currentValue;
      this.hasData = this.results.some((item) => {
        return item.value !== 0;
      });
    }
  }

  @HostListener('window:beforeprint')
  async beforePrint(): Promise<void> {
    this.chart.view = [600, 340];
    this.chart.update();
  }

  @HostListener('window:afterprint')
  async afterPrint(): Promise<void> {
    this.chart.view = null;
    this.chart.update();
  }
}
